import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "filter-site-container" }
const _hoisted_6 = { class: "dataTable" }
const _hoisted_7 = { tabindex: "-1" }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ModalChoixSite = _resolveComponent("ModalChoixSite")!
  const _component_ModalChoixTypeDocuments = _resolveComponent("ModalChoixTypeDocuments")!
  const _component_ModalDownloadDocuments = _resolveComponent("ModalDownloadDocuments")!
  const _component_ModalChoixNomZip = _resolveComponent("ModalChoixNomZip")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.displayModalChoixSite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('document.reglementaire.title')) + " ", 1),
              _createVNode(_component_ReglePastille, { cle: "documentsReglementaires.definition" })
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t('intervention.non-preventive.filter')) + " ", 1),
                _createVNode(_component_ReglePastille, { cle: "documentsReglementaires.filtresDesactives" }),
                (!_ctx.isUniqueSite)
                  ? (_openBlock(), _createBlock(_component_ButtonBlue, {
                      key: 0,
                      disabled: (_ctx.tableData.length === 0 && _ctx.isLoading) || _ctx.isAnalyseRisqueOrPriseEnChargeSelected,
                      "on-click": _ctx.selectionnerSite,
                      text: _ctx.$t('bouton.choix.site'),
                      class: "button-confirm btn"
                    }, null, 8, ["disabled", "on-click", "text"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ButtonBlue, {
                  disabled: _ctx.tableData.length === 0 && _ctx.isLoading,
                  "on-click": _ctx.selectionnerTypeDocument,
                  text: _ctx.$t('bouton.selection.type.documents'),
                  class: "button-confirm btn"
                }, null, 8, ["disabled", "on-click", "text"]),
                _createVNode(_component_ReglePastille, { cle: "documentsReglementaires.choixTypeObligatoire" })
              ]),
              _createVNode(_component_Filter, {
                equipementList: _ctx.equipementListFiltered,
                filter: _ctx.filter,
                groupeList: _ctx.groupeList,
                isEquipementDisabled: _ctx.isAnalyseRisqueOrPriseEnChargeSelected,
                isGroupeDisabled: _ctx.isAnalyseRisqueOrPriseEnChargeSelected,
                isSousGroupeDisabled: _ctx.isAnalyseRisqueOrPriseEnChargeSelected,
                searchSite: _ctx.searchSite,
                sousGroupeList: _ctx.sousGroupeList,
                class: "filter",
                onAddFilterEquipement: _ctx.addFilterEquipement,
                onAddFilterGroupe: _ctx.addFilterGroupe,
                onAddFilterSousGroupe: _ctx.addFilterSousGroupe,
                onClearFilter: _ctx.clearFilter,
                onEquipementToggleSelectAll: _ctx.equipementToggleSelectAll,
                onGroupeToggleSelectAll: _ctx.groupeToggleSelectAll,
                onRemoveFilterEquipement: _ctx.removeFilterEquipement,
                onRemoveFilterGroupe: _ctx.removeFilterGroupe,
                onRemoveFilterSousGroupe: _ctx.removeFilterSousGroupe,
                onSearch: _ctx.doFilter,
                onSetDocumentDateFrom: _ctx.setDocumentDateFrom,
                onSetDocumentDateTo: _ctx.setDocumentDateTo,
                onSiteToggleSelectAll: _ctx.siteToggleSelectAll,
                onSousGroupeToggleSelectAll: _ctx.sousGroupeToggleSelectAll
              }, null, 8, ["equipementList", "filter", "groupeList", "isEquipementDisabled", "isGroupeDisabled", "isSousGroupeDisabled", "searchSite", "sousGroupeList", "onAddFilterEquipement", "onAddFilterGroupe", "onAddFilterSousGroupe", "onClearFilter", "onEquipementToggleSelectAll", "onGroupeToggleSelectAll", "onRemoveFilterEquipement", "onRemoveFilterGroupe", "onRemoveFilterSousGroupe", "onSearch", "onSetDocumentDateFrom", "onSetDocumentDateTo", "onSiteToggleSelectAll", "onSousGroupeToggleSelectAll"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$tc('document.reglementaire.dataTable.title', +_ctx.count)) + " ", 1),
                  _createVNode(_component_ReglePastille, { cle: "documentsReglementaires.portee" })
                ]),
                (_ctx.isPriseEnChargeSelected)
                  ? (_openBlock(), _createBlock(_component_ReglePastille, {
                      key: 0,
                      cle: "documentsReglementaires.telechargementIndisponiblePriseEnCharge"
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isPriseEnChargeSelected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (!_ctx.isDownloadDisabled)
                        ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                            key: 0,
                            imgUrl: _ctx.iconeDownload,
                            title: _ctx.$t('list.download.selection'),
                            class: "button-left",
                            onClick: _ctx.downloadDocuments
                          }, null, 8, ["imgUrl", "title", "onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.count > 0)
                        ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                            key: 1,
                            imgUrl: _ctx.iconeDownload,
                            title: _ctx.$t('list.download.all'),
                            class: "button-right",
                            onClick: _ctx.downloadAll
                          }, null, 8, ["imgUrl", "title", "onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.tableData.length === 0 && _ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                    key: 0,
                    class: "loader"
                  }))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    ref: "content",
                    class: "datatable-container-smaller",
                    onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
                  }, [
                    (
                            _ctx.filter.documentTypeList == null ||
                            _ctx.filter.documentTypeList.length === 0 ||
                            _ctx.filter.documentTypeList[0]?.code !== 'ANALYSE_RISQUE' &&
                            _ctx.filter.documentTypeList[0]?.code !== 'PRISE_EN_CHARGE'
                        )
                      ? (_openBlock(), _createBlock(_component_DataTable, {
                          key: 0,
                          documentListToDownload: _ctx.documentListToDownload,
                          isLoading: _ctx.isLoading,
                          noDataText: _ctx.$t('search.notFound'),
                          tableData: _ctx.tableData,
                          tableHeader: _ctx.tableHeader,
                          onSelect: _ctx.doSelect,
                          onSort: _ctx.doSort
                        }, null, 8, ["documentListToDownload", "isLoading", "noDataText", "tableData", "tableHeader", "onSelect", "onSort"]))
                      : (_ctx.filter.documentTypeList[0]?.code === 'ANALYSE_RISQUE')
                        ? (_openBlock(), _createBlock(_component_DataTable, {
                            key: 1,
                            documentListToDownload: _ctx.documentListToDownload,
                            isLoading: _ctx.isLoading,
                            noDataText: _ctx.$t('search.notFound'),
                            tableData: _ctx.tableDataAdr,
                            tableHeader: _ctx.tableHeaderAdr,
                            onSelect: _ctx.doSelectAdr,
                            onSort: _ctx.doSortAdr
                          }, null, 8, ["documentListToDownload", "isLoading", "noDataText", "tableData", "tableHeader", "onSelect", "onSort"]))
                        : (_openBlock(), _createBlock(_component_DataTable, {
                            key: 2,
                            isLoading: _ctx.isLoading,
                            noDataText: _ctx.$t('search.notFound'),
                            stopPropaOnPdf: true,
                            tableData: _ctx.tableDataPriseEnCharge,
                            tableHeader: _ctx.tableHeaderPriseEnCharge,
                            onDownloadPdf: _ctx.downloadPriseEnChargePdf
                          }, null, 8, ["isLoading", "noDataText", "tableData", "tableHeader", "onDownloadPdf"]))
                  ], 544))
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_ModalChoixSite, {
          key: 1,
          "is-multi-site": true,
          "inclure-termines": true,
          "selected-site": null,
          "selected-sites": _ctx.filter.siteList,
          onCancel: _ctx.modalChoixSiteCancel,
          onValider: _ctx.validerSite
        }, null, 8, ["selected-sites", "onCancel", "onValider"])),
    (_ctx.displayModalTypeDocument && !_ctx.isListTypesLoading)
      ? (_openBlock(), _createBlock(_component_ModalChoixTypeDocuments, {
          key: 2,
          "selected-types": _ctx.filter.documentTypeList,
          "types-documents": _ctx.typeDocumentList,
          onCancel: _ctx.modaleChoixTypesCancel,
          onValider: _ctx.validerTypes
        }, null, 8, ["selected-types", "types-documents", "onCancel", "onValider"]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_ModalDownloadDocuments, {
          key: 3,
          documentTypeList: _ctx.typeDocumentList,
          "nb-documents-modal": _ctx.nbDocumentsModal,
          onCancel: _ctx.cancel,
          onDownloadDocuments: _ctx.setFilterForDownloadAllDocuments
        }, null, 8, ["documentTypeList", "nb-documents-modal", "onCancel", "onDownloadDocuments"]))
      : _createCommentVNode("", true),
    (_ctx.showModalNomZip)
      ? (_openBlock(), _createBlock(_component_ModalChoixNomZip, {
          key: 4,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalNomZip = false)),
          onDownload: _ctx.downloadAllDocuments
        }, null, 8, ["onDownload"]))
      : _createCommentVNode("", true),
    (_ctx.isZipLoading || _ctx.isListTypesLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 5 }))
      : _createCommentVNode("", true)
  ], 64))
}